import { string } from 'joi'
import { get, remove, handleClientError } from '../lib'

interface ResponseType {
  id: string
  analyzer: {
    id: string
    name: string
  }
  datasets: Array<{
    id: string
    name: string
  }>
  job_id: string
  script: {
    id: string
    name: string
  }
  configs: Array<{
    id: string
    name: string
  }>
  file: Array<{
    id: string
    size: number
    extension: string
    filename: string
    created_at: string
  }>
  status: string
  created_at: string
  updated_at: string
}

interface ResponseFile {
  file: string
  filename: string
  ipa_result_id: string
}

export const getAllResults = async (
  query: {
    [k: string]: string | number
  } = {}
): Promise<ResponseType[]> => {
  return get<ResponseType[]>({
    path: '/ipa/result',
    query
  })
}

export const getResult = async (
  result_id: string,
  query: {
    [k: string]: string | number
  } = {}
): Promise<ResponseType> => {
  return get<ResponseType>({
    path: `/ipa/result/${result_id}`,
    query
  })
}

export const getResultFileData = async (
  resultFileId: string,
  query: {
    [k: string]: string
  } = {}
): Promise<ResponseFile> => {
  return get<ResponseFile>({
    path: `/ipa/result/file/${resultFileId}`,
    query
  })
}

export const removeResult = async (id: string): Promise<null> => {
  return remove({
    path: '/ipa/result',
    id
  })
}
